<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <strong>{{ labels.triggerProducts }}</strong>
        </div>
        <div class="panel-body">
            <gift-campaign-trigger-row
                v-for="(trigger, index) in triggers"
                :key="trigger._key"
                :trigger="trigger"
                :index="index"
                :active-options="activeOptions"
                :labels="labels"
                :search-url="searchUrl"
                :validation-errors="validationErrors"
                :start-in-edit-mode="trigger._startInEditMode === true"
                :campaign-mode="campaignMode"
                :disabled="disabled"
                @update="updateTrigger(index, $event)"
                @delete="removeTrigger(index)"
            ></gift-campaign-trigger-row>

            <p v-if="triggers.length === 0" class="text-muted">{{ labels.noTriggers }}</p>

            <button v-if="!disabled" type="button" class="btn btn-default" @click="addTrigger">
                {{ labels.addTrigger }}
            </button>
        </div>
    </div>
</template>

<script>
import GiftCampaignTriggerRow from './GiftCampaignTriggerRow.vue';

export default {
    components: {
        GiftCampaignTriggerRow,
    },
    props: {
        triggers: {
            type: Array,
            required: true,
        },
        activeOptions: {
            type: Object,
            required: true,
        },
        labels: {
            type: Object,
            required: true,
        },
        searchUrl: {
            type: String,
            required: true,
        },
        validationErrors: {
            type: Object,
            default: () => ({}),
        },
        campaignMode: {
            type: String,
            default: 'create',
            validator: (value) => ['create', 'edit', 'show'].includes(value),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:triggers'],
    methods: {
        updateTrigger(index, trigger) {
            const next = [...this.triggers];
            next[index] = { ...trigger, _key: this.triggers[index]._key };
            this.$emit('update:triggers', next);
        },
        removeTrigger(index) {
            const next = [...this.triggers];
            next.splice(index, 1);
            this.$emit('update:triggers', next);
        },
        addTrigger() {
            const next = [
                ...this.triggers,
                {
                    _key: `new-${Date.now()}-${Math.random().toString(36).slice(2)}`,
                    _startInEditMode: true,
                    id: null,
                    condition_value: '',
                    trigger_product_id: null,
                    trigger_product_primary_artist: null,
                    trigger_product_title: null,
                    gift_quantity: 1,
                    active: true,
                },
            ];
            this.$emit('update:triggers', next);
        },
    },
};
</script>
